export const permissions = {
  general: {
    QUEUE_MONITORING: {
      VIEW: 'ccpro/general/queueMonitoring/queues:view',
      AGENT_ACTIVITY_VIEW: 'ccpro/general/queueMonitoring/agentActivity:view',
      AGENT_ACTIVITY_EDIT: 'ccpro/general/queueMonitoring/agentActivity:edit',
    },
    ACTION_CALL_OPTIONS: {
      CALL_RECORDINGS: {
        EDIT: 'ccpro/general/actionCallOptions/callRecordings:edit',
      },
    },
  },
  manager: {
    CONVERSATION_DETAILS: {
      RECORDING_TRANSCRIPT_SECTION_VIEW: 'ccpro/general/callRecordings:view',
    },
    CONVERSATION_SENTIMENT: {
      VIEW_OWN: 'ccpro/general/conversations/AI:view',
      EDIT_ALL: 'ccpro/general/conversations/AI/analysis:edit',
    },
    CONVERSATION_OVERVIEW: {
      EDIT_OWN: 'ccpro/general/conversations/historical/user:edit',
      EDIT_ALL: 'ccpro/general/conversations/historical/all:edit',
    },
  },
  admin: {
    VIRTUAL_AGENT: {
      VIEW: 'ccpro/admin/virtualAgents:view',
      EDIT: 'ccpro/admin/virtualAgents:edit',
    },
    TELECOM_WORKFLOWS: {
      LINES_AND_DEVICES: 'ccpro/admin/telecom/linesAndDevices:edit',
      VIEW: 'ccpro/admin/telecom/workflows:view',
      EDIT: 'ccpro/admin/telecom/workflows:edit',
    },
    USER_MANAGEMENT: {
      VIEW: 'ccpro/admin/users:view',
      QUEUES_EDIT: 'ccpro/admin/users/queues:edit',
      SEAT_LEVELS_EDIT: 'ccpro/admin/users/seatLevels:edit',
    },
  },
} as const;

export const permissionSets = {
  general: {
    QUEUE_MONITORING: Object.values(permissions.general.QUEUE_MONITORING),
  },
  manager: {
    CONVERSATION_SENTIMENT: Object.values(
      permissions.manager.CONVERSATION_SENTIMENT,
    ),
  },
  admin: {
    VIRTUAL_AGENT: Object.values(permissions.admin.VIRTUAL_AGENT),
    TELECOM_WORKFLOWS: Object.values(permissions.admin.TELECOM_WORKFLOWS),
    USER_MANAGEMENT: Object.values(permissions.admin.USER_MANAGEMENT),
    ALL: [
      ...Object.values(permissions.admin.VIRTUAL_AGENT),
      ...Object.values(permissions.admin.TELECOM_WORKFLOWS),
      ...Object.values(permissions.admin.USER_MANAGEMENT),
    ],
  },
};
